import React from 'react';

import { Heading, Container, Row, Col } from 'aplazame-design-system';

import CardStoreComponent from '../CardStoreComponent';


export default function OffersSection({
    title,
    titleTag,
    offers,
    id,
    utm
}) {
    return (
        <section aria-labelledby={id}>
            <Container
                pt={{ xs: 20 }}
                pb={{ xs: 10 }}
            >
                <Row>
                    {title ? (
                        <Col>
                            <Heading
                                id={id}
                                className="h3 font-weight-bold mb-8 mb-lg-6"
                                tag={titleTag}
                                data-sal="slide-up"
                                data-sal-easing="ease-out-quart"
                            >
                                {title}
                            </Heading>
                        </Col>
                    ) : null}
                    {offers.filter(offer => !!offer.store).map((offer, i) => (
                        <Col
                            key={i}
                            col={{
                                md: 6,
                                lg: 4
                            }}
                            mb={{ xs: 10 }}
                            data-sal="slide-up"
                            data-sal-easing="ease-out-quart"
                            data-sal-delay={`xs-none--lg-${i * 100}`}
                        >
                            <CardStoreComponent
                                utm={utm}
                                {...offer.store}
                                {...offer}
                            />
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
}